import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import { OrganizationsService } from '../../../services';
import BlackListGetters from './getters';
import BlackListMutations from './mutations';
import BlackListState from './state';

const organizationsService = new OrganizationsService();

export default class BlackListActions extends Actions<
  BlackListState,
  BlackListGetters,
  BlackListMutations,
  // eslint-disable-next-line no-use-before-define
  BlackListActions
> {
  async get_organization_black_list() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_BLACK_LISTS(true);
      const { data, meta } = await organizationsService.get_organization_black_list(payload);

      this.mutations.SET_BLACK_LISTS(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_BLACK_LISTS(false);
    }
  }
}
